/* global global, document, Raven */
/* eslint new-parens: 0 */
/* eslint no-new: 0 */
/* eslint import/no-extraneous-dependencies: 0 */
// solve bootstrap import alias ^

import jQuery from 'jquery';
import 'jquery-migrate';
import 'bootstrap';
import Backbone from 'backbone';

import Cookies from 'js-cookie';
import anchorJS from 'anchorJS';

import User from 'app/models/user';
import ApiModeSelection from 'app/models/api_mode_selection';

import DefaultRouter from 'app/routers/default_router';
import AccountRouter from 'app/routers/account_router';
import { getQueryParams } from 'utils/wrappers';
import BasicNavbarView from 'app/views/basic_navbar_view';
import LeadGatherButtonComponent from 'app/views/lead_gather_button_component';

/* global views, referenced from pages, to be removed later */
import APIDocsPage from 'app/views/api_docs_page';
import CanadaPostAccountCallbackPage from 'app/views/canada_post_account_callback_page';
import CanadaPostAccountRegistrationPage from 'app/views/canada_post_account_registration_page';
import ScrollspyPage from 'app/views/scrollspy_page';
import UpsAccountRegistrationPage from 'app/views/ups_account_registration_page';
import USPSRateChartPage from 'app/views/usps_rate_chart_page';

import addAdroll from 'utils/adroll';

import saveAs from '../../vendor/FileSaver';

global.saveAs = saveAs;
global.anchorJS = anchorJS;
global.jQuery = global.$ = jQuery;

const EasyPost = global.EasyPost = {
  Collections: {},
  Models: {},
  Routers: {},
  Utils: {},
  Views: {
    APIDocsPage,
    CanadaPostAccountCallbackPage,
    CanadaPostAccountRegistrationPage,
    ScrollspyPage,
    UpsAccountRegistrationPage,
    USPSRateChartPage,
  },
  Globals: {},

  initialize() {
    const affixAutoTopList = $('.affix-auto-top');
    if (affixAutoTopList.length) {
      const affixAutoBottom = $('.affix-auto-bottom');
      affixAutoTopList.each((idx, elem) => {
        const el = $(elem);
        if (affixAutoBottom.length) {
          el.affix({
            offset: {
              top: el.offset().top,
              bottom: (
                $(document).height() -
                affixAutoBottom.offset().top -
                affixAutoBottom.outerHeight(true)
              ),
            },
          });
        } else {
          el.affix({ offset: { top: el.offset().top } });
        }
      });
    }

    EasyPost.Globals.apiModeSelection = new ApiModeSelection({});

    const user = new User({});
    EasyPost.Globals.currentUser = user;
    EasyPost.Globals.firstFetchComplete = false;
    user.once('sync', (model) => {
      Raven.setUserContext({
        id: model.get('id'),
        email: model.get('email'),
      });
    });
    user.once('sync error', () => {
      EasyPost.Globals.firstFetchComplete = true;
    });
    user.once('error', () => {
      if (!EasyPost.Globals.currentRouter || !EasyPost.Globals.currentRouter.loggedIn) {
        addAdroll();
      } // Only if not on a logged-in or otherwise sensitive page
    });

    new BasicNavbarView({ el: '#backbone_navbar', model: user }).render();
    user.fetch();

    $('a.btn[data-target="#lead-gather-modal"], button[data-target="#lead-gather-modal"]').each((idx, el) => (
      new LeadGatherButtonComponent({ el, source: $(el).data('source'), user })
    ));

    $('body').on('shown.bs.modal', () => {
      $('.modal-dialog input:visible:first').focus();
    });

    jQuery.expr.pseudos.icontains = jQuery.expr.createPseudo(function (arg) {
      return function (elem) {
        return jQuery(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
      };
    });

    // for signup Analytics
    const utm_source = getQueryParams().utm_source;
    if (utm_source) {
      if (!Cookies.get('firstTouch')) {
        Cookies.set('firstTouch', utm_source);
      }
      Cookies.set('lastTouch', utm_source);
    }

    new DefaultRouter;
    new AccountRouter;
    Backbone.history.start({ pushState: true });
  },
};

$(EasyPost.initialize);



// WEBPACK FOOTER //
// ./app/root.js